<template>
    <div class="content">
        <div class="row">
            <div class="col-12">
                <div class="loading" v-if="asyncDone === false">Loading&#8230;</div>
            </div>
            <div class="col-12 mr-auto ml-auto">
                <!--      Wizard container        -->
                <div class="wizard-container">
                    <div class="card card-wizard animated fadeIn" data-color="primary" id="wizardProfile">
                        <form action="" method="">
                            <div class="card-header text-center">
                                <h3 class="card-title">
                                    Migration Request
                                </h3>
                                <h5 class="description" style="color: #000000">Please be as accurate as possible, and be sure to let us know if there is anything at all we can help with!</h5>
                                <div class="wizard-navigation">
                                    <ul>
                                        <li class="nav-item">
                                            <a class="nav-link active" href="#introduction" data-toggle="tab" role="tab" aria-controls="introduction" aria-selected="true">
                                                <i class="nc-icon nc-single-02"></i> Introduction
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#siteDetails" data-toggle="tab" role="tab" aria-controls="account" aria-selected="true">
                                                <i class="nc-icon nc-world-2"></i> Site Details
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#domainDetails" data-toggle="tab" role="tab" aria-controls="address" aria-selected="true">
                                                <i class="nc-icon nc-app"></i> Domain Details
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#additionalDetails" data-toggle="tab" role="tab" aria-controls="address" aria-selected="true">
                                                <i class="nc-icon nc-atom"></i> Additional Details
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#email" data-toggle="tab" role="tab" aria-controls="address" aria-selected="true">
                                                <i class="nc-icon nc-email-85"></i> Email
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" href="#overview" data-toggle="tab" role="tab" aria-controls="address" aria-selected="true">
                                                <i class="nc-icon nc-spaceship"></i> Overview &amp; Finalize
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="tab-content">
                                    <Introduction :planIndex="pIndex" :collaboration="true" :userUID="userUID" :supervisor="supervisor" />
                                    <SiteDetails :collaboration="true" :collaboratorUID="userUID" :supervisor="supervisor" />
                                    <DomainDetails />
                                    <AdditionalDetails />
                                    <EmailDetails />
                                    <Overview :collaboration="true" :supervisorUID="userUID" :supervisor="supervisor" />
                                </div>
                            </div>
                            <div class="card-footer pb-4">
                                <div class="pull-right">
                                    <button type='button' class='btn btn-next btn-fill btn-rose btn-wd btn-primary' name='next' @click="next"
                                            :disabled="!hostVideoAccessResponseFlag || (shouldAddCollaborator && addedCollaborators.length === 0)">Next</button>
                                    <button type='button' class='btn btn-finish btn-fill btn-rose btn-wd btn-primary d-none' name='finish'>Finish</button>
                                </div>
                                <div class="pull-left">
                                    <button type='button' class='btn btn-previous btn-fill btn-default btn-wd btn-primary' :disabled="!hostVideoAccessResponseFlag" name='previous'>Previous</button>
                                </div>
                                <div class="clearfix"></div>
                            </div>
                        </form>
                    </div>
                </div>
                <!-- wizard container -->
            </div>
        </div>
    </div>
</template>

<script>
    import { eventBus } from "../../../main";
    export default {
        name: "NewMigration",
        components: {
            Introduction: () =>
                import(/* webpackChunkName: "migrationIntro" */ "../../../components/User/Migration/RequestMigration/Introduction.vue"),
            SiteDetails: () =>
                import(/* webpackChunkName: "migrationSiteDetails" */ "../../../components/User/Migration/RequestMigration/SiteDetails.vue"),
            DomainDetails: () =>
                import(/* webpackChunkName: "migrationDomainDetails" */ "../../../components/User/Migration/RequestMigration/DomainDetails.vue"),
            AdditionalDetails: () =>
                import(/* webpackChunkName: "migrationAdditionalDetails" */ "../../../components/User/Migration/RequestMigration/AdditionalDetails.vue"),
            EmailDetails: () =>
                import(/* webpackChunkName: "migrationEmailDetails" */ "../../../components/User/Migration/RequestMigration/EmailDetails.vue"),
            Overview: () =>
                import(/* webpackChunkName: "migrationOverview" */ "../../../components/User/Migration/RequestMigration/OverviewFinalize.vue")
        },
        props: {
            pIndex: Number,
            userUID: {
                type: String
            },
            supervisor: {
                type: Object,
                default () { return {}; }
            }
        },
        methods: {
            next() {
                eventBus.$emit("nextPage", { page: document.querySelector('.moving-tab').textContent.toLowerCase().trim() });
            }
        },
        computed: {
            asyncDone() {
                return this.$store.getters["async/state"];
            },
            hostVideoAccessResponseFlag() {
              return this.$store.getters["migration/getHostVideoAccessResponseFlag"];
            },
            shouldAddCollaborator() {
              return this.$store.getters["migration/shouldAddCollaborator"];
            },
            addedCollaborators() {
              return this.$store.getters["migration/getAddedCollaborators"];
            },
        },
        created() {
            /* eslint-disable */
            $(document).ready(function() {
                // Initialise the wizard
                demo.initWizard();
                console.log('Created Called Migration');
                setTimeout(function() {
                    $(".moving-tab").css('width', '253px');
                    $(".card.card-wizard").addClass("active");
                }, 600);
            });
            /* eslint-enable */
        },
        updated(){
            console.log('Updated Called Migration');
            /* eslint-disable */
            $(document).ready(function() {
                // Initialise the wizard
                demo.initWizard({
                    title: 'Hello Sir'
                });
                setTimeout(function() {
                    $(".card.card-wizard").addClass("active");
                }, 600);
            });
            /* eslint-enable */
        }
    }
</script>

<style lang="scss">
    .wizard-navigation {
        .nav-pills {
            .nav-item {
                a {
                    cursor: context-menu;
                    &:hover {
                        cursor: context-menu;
                    }
                }
            }
        }
        .moving-tab {
            cursor: context-menu;
        }
    }
</style>
